import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav, Dropdown, Badge, Button } from 'react-bootstrap';
import { Bell, PersonCircle, Gear, BoxArrowRight, List, Shield } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/login';
import { getUnreadCount } from '../../services/notifications'; // Fixed import

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    // Load user data from localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setUserData(user);
    
    // Fetch unread notifications
    fetchUnreadNotifications();
    
    // Set up polling for new notifications
    const interval = setInterval(fetchUnreadNotifications, 30000); // Every 30 seconds
    
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadNotifications = async () => {
    try {
      const count = await getUnreadCount();
      setUnreadCount(count);
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      setUnreadCount(0); // Set to 0 on error
    }
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Even if the API call fails, clear local storage and redirect
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      navigate('/login');
    }
  };

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  return (
    <Navbar bg="white" className="shadow-sm border-bottom sticky-top" style={{ zIndex: 1020 }}>
      <Container fluid className="px-4">
        <div className="d-flex align-items-center">
          {/* Mobile menu button */}
          <Button 
            variant="outline-primary" 
            className="d-lg-none me-3 p-1" 
            onClick={toggleSidebar}
            style={{ width: '38px', height: '38px' }}
          >
            <List size={20} />
          </Button>
          
          <Navbar.Text className="text-muted me-3">
            Welcome back, <span className="fw-semibold text-dark">{userData.email || 'Administrator'}</span>
          </Navbar.Text>
        </div>
        
        <Nav className="ms-auto align-items-center">
          {/* Notifications */}
          <Nav.Item className="me-3">
            <Button
              variant="outline-light"
              className="position-relative p-2 rounded-circle"
              onClick={handleNotificationClick}
              style={{ border: 'none' }}
            >
              <Bell size={20} className="text-dark" />
              {unreadCount > 0 && (
                <Badge 
                  bg="danger" 
                  pill 
                  className="position-absolute top-0 start-100 translate-middle"
                  style={{ fontSize: '0.7rem' }}
                >
                  {unreadCount > 99 ? '99+' : unreadCount}
                </Badge>
              )}
            </Button>
          </Nav.Item>

          {/* User Dropdown */}
          <Dropdown align="end">
            <Dropdown.Toggle 
              variant="light" 
              id="dropdown-user" 
              className="d-flex align-items-center border-0 shadow-sm px-3 py-2"
              style={{ backgroundColor: '#f8f9fa' }}
            >
              <PersonCircle size={24} className="me-2 text-primary" />
              <div className="text-start d-none d-md-block">
                <div className="fw-semibold text-dark" style={{ fontSize: '0.9rem' }}>
                  {userData.email ? userData.email.split('@')[0] : 'Admin'}
                </div>
                <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                  {userData.is_admin ? 'Administrator' : 'User'}
                </div>
              </div>
            </Dropdown.Toggle>
            
            <Dropdown.Menu className="shadow border-0 mt-2" style={{ minWidth: '200px' }}>
              <Dropdown.Header className="text-muted small">Account</Dropdown.Header>
              
              <Dropdown.Item 
                className="d-flex align-items-center py-2"
                onClick={() => navigate('/profile')}
              >
                <PersonCircle className="me-2" size={16} />
                Profile Settings
              </Dropdown.Item>
              
              <Dropdown.Item 
                className="d-flex align-items-center py-2"
                onClick={() => navigate('/settings')}
              >
                <Gear className="me-2" size={16} />
                System Settings
              </Dropdown.Item>
              
              {userData.is_admin && (
                <Dropdown.Item 
                  className="d-flex align-items-center py-2"
                  onClick={() => navigate('/admin')}
                >
                  <Shield className="me-2" size={16} />
                  Admin Panel
                </Dropdown.Item>
              )}
              
              <Dropdown.Divider />
              
              <Dropdown.Item 
                className="d-flex align-items-center py-2 text-danger"
                onClick={handleLogout}
                style={{ cursor: 'pointer' }}
              >
                <BoxArrowRight className="me-2" size={16} />
                Sign Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Header;